export enum InteractionTypeEnum {
  Message = 'Message',
  Question = 'Question',
  Permission = 'Permission',
  Stop = 'Stop'
}
